module.exports = __webpack_public_path__ + "static/media/tax-setup.5cd23c0c.svg";